import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Menu.css';

const HERO_IMG = '/food3.png';
const MENU_IMG = '/food2.png';

const menuData = {
  Appetizers: [
    { name: 'Steamed Mussels', desc: 'Tossed with lemon white wine and garlic sauce', price: '13' },
    { name: 'Stuffed Zucchini', desc: 'Stuffed with a mixture of ground beef, onions, capers, ammoghio and marinara topped with melted cheese', price: '13' },
    { name: 'Pan Fried Calamari', desc: 'Squid', price: '13' },
    { name: 'Shrimp Cocktail', desc: 'Jumbo shrimp with cocktail sauce', price: '12' },
    { name: 'Shrimp Casalinga', desc: 'Jumbo breaded shrimp with sautéed scallions in a creamy white sauce', price: '12' },
    { name: 'Shrimp Al Ferri', desc: 'Charbroiled shrimp marinated in lemon, olive oil, garlic and herbs', price: '13' },
    { name: 'Mozzarella Fritta', desc: 'Freshly sliced and hand breaded mozzarella sticks', price: '10' },
    { name: "Giuseppe's Pizza Bread", desc: 'Bruschetta with ammoghio and melted cheese', price: '8' },
  ],
  'Soups & Salads': [
    { name: 'Soup of the Day', desc: 'Cup $3.50 · Bowl $4.00', price: '3.50' },
    { name: 'French Onion Soup', desc: 'A bubbling crock of homemade onion soup topped with 3 cheeses', price: '5' },
    { name: 'Antipasto Salad', desc: 'Salami, cheese, olives, pepperoncini and tomatoes served with House dressing', price: '16' },
    { name: 'Caesar Salad', desc: 'Cold crisp romaine lettuce tossed in a homemade Caesar dressing topped with croutons, romano and parmesan cheeses', price: '14' },
    { name: 'California Chicken Salad', desc: 'Crispy garden salad topped with char grilled chicken breast, bacon bits, dried cherries, pecans, tomato, cucumber, red onions served with Raspberry Vinaigrette dressing', price: '16' },
    { name: 'Insalata Rossa', desc: 'Roma tomatoes, red onions, olives and pepperoncini in an Olive Oil and Vinaigrette dressing', price: '10' },
  ],
  'Italian Specialties': [
    { name: 'Spaghetti, Mostaccioli or Linguini', desc: 'With marinara or meat sauce. Add 1 sausage $3 · Add 2 meatballs $6', price: '16' },
    { name: 'Manicotti', desc: 'Pasta filled with ricotta cheese topped with mozzarella cheese and marinara or meat sauce', price: '17' },
    { name: 'Cannellini', desc: 'Pasta filled with ground beef and Italian spices topped with melted cheese and meat sauce', price: '17' },
    { name: 'Linguini with Clam Sauce', desc: 'White or Red — Sautéed clams, onions, garlic, capers and Italian herbs tossed in linguini noodles', price: '20' },
    { name: 'Homemade Lasagna', desc: 'Lasagna noodles layered with rich ricotta cheese and meat sauce', price: '18' },
    { name: 'Lobster Ravioli Primavera', desc: 'Pasta pillows filled with lobster then tossed with slivered zucchini, red bell peppers and broccoli florets in a light cream sauce', price: '20' },
    { name: 'Shrimp & Roasted Garlic Ravioli', desc: 'Pasta pillows filled with shrimp and roasted garlic tossed with a zesty arrabbiata sauce', price: '20' },
    { name: 'Meat Ravioli', desc: 'Pasta pillows filled with ground meat topped with meat sauce', price: '17' },
    { name: 'Italian Sausage Ravioli', desc: 'Pasta pillows filled with ground Italian sausage topped with meat sauce', price: '17' },
    { name: 'Ravioli Florentine', desc: 'Pasta pillows filled with ricotta cheese and spinach topped with marinara sauce', price: '17' },
    { name: 'Gnocchi Homemade Potato Dumplings', desc: 'With marinara or meat sauce', price: '17' },
    { name: 'Fettuccini Alfredo', desc: 'Creamy butter parmesan cheese sauce. Add broccoli $1.50 · Add mushrooms $1.50 · Add chicken $5 · Add shrimp $6', price: '17' },
    { name: 'Spaghetti Con Aglio e Olio', desc: 'Oil and garlic with tomatoes. Add chicken $5 · Add shrimp $6', price: '16' },
    { name: 'Eggplant Parmigiana', desc: 'Fresh breaded pan fried eggplant baked with cheeses topped with marinara sauce, served with a side of mostaccioli', price: '17' },
    { name: 'Eggplant Rollentini', desc: 'Thinly sliced eggplant layered with seasoned ricotta and toasted almonds topped with marinara sauce and melted cheese, served with mostaccioli', price: '17' },
    { name: 'Spaghetti Carbonara', desc: "Sautéed bacon and scallions with our own blend of cheesy cream sauce", price: '17' },
    { name: 'Tortellini Palomino or Arrabbiata', desc: 'Cheese tortellini tossed with palomino creamy marinara or arrabbiata zesty marinara', price: '18' },
    { name: 'Pasta Bolognese', desc: 'Pasta in our meat sauce with sausage, ammoghio, mushrooms, scallions and bell peppers', price: '17' },
    { name: 'Baked Italian Combo', desc: '½ lasagna piece, ½ order chicken parmigiana, 2 meat or florentine ravioli topped with meat sauce and melted cheese', price: '20' },
    { name: 'Steak Peppernatta', desc: 'Sautéed strips of New York steak, onions, bell peppers, mushrooms, diced tomatoes, capers and sliced green olives in a burgundy tomato sauce tossed with fettuccine', price: '23' },
  ],
  'Vitello & Carne': [
    { name: '*Marinated New York Steak', desc: 'New York strip steak marinated with our zip sauce. Add onions $1.50 · Add mushrooms $1.50', price: '24' },
    { name: '*Steak Siciliano', desc: 'Breaded steak pan fried in olive oil with a side of ammoghio sauce', price: '24' },
    { name: 'Veal Parmigiana', desc: 'Breaded tender veal topped with homemade sauce and melted mozzarella cheese', price: '21' },
    { name: 'Veal Piccante', desc: 'Tender medallions of veal sautéed with mushrooms and artichoke hearts in a lemon wine sauce served over pasta', price: '21' },
    { name: 'Veal Marsala', desc: 'Tender medallions of veal dusted in flour and sautéed with Marsala wine and fresh mushrooms served over pasta', price: '21' },
    { name: 'Veal Tosca', desc: 'Hand pounded veal dipped in egg batter pan fried in a lemon butter wine sauce served over pasta', price: '21' },
    { name: 'Veal Siciliano', desc: 'Sautéed medallions of veal with tomatoes, mushrooms, green peppers and artichoke hearts with a splash of burgundy served over pasta', price: '21' },
  ],
  Pollo: [
    { name: 'Chicken Parmigiana', desc: 'Breaded tender chicken breast with homemade sauce and melted mozzarella cheese with a side of pasta', price: '19' },
    { name: 'Chicken Tosca', desc: 'Chicken breast dipped in egg batter pan fried topped off with a lemon butter wine sauce served over pasta', price: '19' },
    { name: 'Chicken Marsala', desc: 'Sautéed chicken breast with mushrooms in a Marsala wine sauce served over pasta', price: '19' },
    { name: 'Chicken Piccante', desc: 'Tender medallions of chicken sautéed with mushrooms and artichoke hearts in a lemon wine sauce served over pasta', price: '19' },
    { name: 'Chicken Siciliano', desc: 'Breaded chicken with a side of ammoghio sauce served with a side of pasta', price: '19' },
    { name: 'Traverse City Chicken', desc: 'Chicken breast encrusted in almonds then sautéed with scallions and dried cherries in a creamy cherry wine sauce served over angel hair pasta', price: '19' },
  ],
  Pesce: [
    { name: 'Orange Roughy Pizziolla', desc: 'Encrusted with parmesan cheese sautéed in olive oil topped with ammoghio sauce over pasta', price: '22' },
    { name: 'Grilled Salmon', desc: 'Grilled salmon served with angel hair pasta topped with lemon white wine and garlic sauce', price: '22' },
    { name: 'Beer Battered Fish and Chips', desc: 'Served with French fries or pasta', price: '17' },
    { name: 'Shrimp Casalinga', desc: 'Breaded jumbo shrimp pan fried tossed with capers and scallions in a creamy white sauce tossed with angel hair pasta', price: '20' },
    { name: 'Shrimp Scampi', desc: 'Jumbo shrimp sautéed in the traditional garlic butter scampi sauce served over angel hair pasta', price: '20' },
    { name: 'Seafood Fettuccini', desc: 'Sautéed shrimp, orange roughy and clams in a creamy alfredo sauce tossed with fettuccini', price: '24' },
  ],
  Beverages: [
    { name: 'House Wines by the glass', desc: 'Chardonnay, Piesporter, White Zinfandel, Merlot, Chianti, Lambrusco, Cabernet, Chianti Placibo', price: '8' },
    { name: 'Premium Wines by the glass', desc: 'Merlot, Red Moscato, Sangria, Nero d\'Avola, Feudo Sartanna, Sicily, Sauvignon Blanc', price: '9' },
    { name: 'Ultra Premium Wines by the glass', desc: 'Late Harvest Riesling, Pinot Noir, Pinot Grigio, Roscato, Masi Valpolicella, Gavi di Gavi, Principessa, Italy', price: '10.50' },
    { name: 'Domestic Beer', desc: 'Bud, Bud Light, Coors Light, Michelob Ultra, Miller Lite', price: '4' },
    { name: 'Import Beer', desc: 'Corona, Heineken, Labatt\'s, Labatt Blue Light, Peroni', price: '5' },
    { name: 'Coffee / Tea / Espresso', desc: 'Coffee, Tea (Hot, Cold or Decaf), Espresso', price: '4' },
    { name: 'Cappuccino', desc: '', price: '5' },
    { name: 'Soft Drinks', desc: 'Pepsi products', price: '4' },
    { name: 'Shirley Temple / Strawberry Lemonade', desc: 'Or Virgin Strawberry Daiquiri', price: '4' },
  ],
};

const categoryNotes = {
  'Italian Specialties': 'All Entrées include Soup or Salad and Giuseppe Bread',
  'Vitello & Carne': 'Served with Pasta, Soup of the Day or Salad and Giuseppe Rolls',
  Pollo: 'Served with Pasta, Soup of the Day or Salad and Giuseppe Rolls',
  Pesce: 'Served with Pasta, Soup of the Day or Salad and Giuseppe Rolls',
};

const enhancers = [
  { name: 'Chicken', price: '5' },
  { name: 'Shrimp (3)', price: '6' },
  { name: 'Meatballs each', price: '3' },
  { name: 'Italian Sausage', price: '3' },
  { name: 'Mushrooms', price: '1.50' },
  { name: 'Baked Cheese', price: '2.50' },
  { name: 'Baby Caesar (instead of dinner salad)', price: '4' },
  { name: 'Tossed Salad', price: '3.50' },
  { name: 'Broccoli', price: '1.50' },
  { name: 'French Fries', price: '4.50' },
  { name: 'Side Pasta Mostaccioli', price: '7' },
  { name: 'Side Pasta Fettuccine Alfredo', price: '8.50' },
];

export default function Menu() {
  const categories = Object.keys(menuData);
  const [active, setActive] = useState(categories[0]);

  return (
    <main>
      <div className="page-hero">
        <img src={HERO_IMG} alt="Italian food spread" />
        <div className="page-hero-content">
          <p style={{ fontFamily: 'Cormorant Garamond, serif', fontStyle: 'italic', fontSize: '1rem', letterSpacing: '0.2em', color: 'var(--gold-pale)', marginBottom: '0.5rem' }}>Authentic Italian</p>
          <h1>A Taste of Italy<br /><em style={{ fontSize: '0.75em' }}>in Every Bite</em></h1>
          <a href="tel:5869484900" className="phone-link">586-948-4900</a>
        </div>
      </div>

      <div className="gold-bar" />

      {/* Intro */}
      <section className="section menu-intro">
        <div className="container menu-intro__inner">
          <div className="menu-intro__img">
            <img src={MENU_IMG} alt="Italian pasta dish" />
          </div>
          <div className="menu-intro__text">
            <h2 className="section-title">True Blue Italian Dishes<br />Cooked to Perfection</h2>
            <div className="divider-ornament"><span>✦</span></div>
            <p>
              For more than 25 years, Giuseppe's Restaurant has been offering nothing less than
              flavorful soul food. Every dish is prepared using farm-fresh produce and homemade
              ingredients passed down through generations.
            </p>
            <p>
              Browse our menu and try the all-time Italian favorites you can enjoy right here in
              Chesterfield, Michigan.
            </p>
          </div>
        </div>
      </section>

      {/* Menu */}
      <section className="section menu-section">
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center' }}>Our Menu</h2>
          <div className="divider-ornament" style={{ margin: '1rem auto 2.5rem' }}><span>✦</span></div>

          {/* Category Tabs */}
          <div className="menu-tabs">
            {categories.map(cat => (
              <button
                key={cat}
                className={`menu-tab ${active === cat ? 'active' : ''}`}
                onClick={() => setActive(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Category note */}
          {categoryNotes[active] && (
            <p className="menu-category-note">{categoryNotes[active]}</p>
          )}

          {/* Items */}
          <div className="menu-items">
            {menuData[active].map(item => (
              <div className="menu-item" key={item.name}>
                <div className="menu-item__info">
                  <h4>{item.name}</h4>
                  {item.desc && <p>{item.desc}</p>}
                </div>
                <div className="menu-item__price">${item.price}</div>
              </div>
            ))}
          </div>

          <p className="menu-note">* Menu items and prices subject to change. Please call for the most current offerings.<br />* Consuming raw or undercooked meats, poultry, seafood, shellfish or eggs may increase your risk of food borne illness.</p>
        </div>
      </section>

      {/* Enhance Your Entree */}
      <section className="section enhance-section">
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center' }}>Enhance Your Entrée</h2>
          <div className="divider-ornament" style={{ margin: '1rem auto 2.5rem' }}><span>✦</span></div>
          <div className="enhance-grid">
            {enhancers.map(item => (
              <div className="enhance-item" key={item.name}>
                <span>{item.name}</span>
                <span className="enhance-price">${item.price}</span>
              </div>
            ))}
          </div>
          <p className="menu-note" style={{ textAlign: 'center', marginTop: '2rem' }}>
            Take home any of our great Soups or Sauces by the Quart — ask your server.<br />
            Meat Sauce $12 · Marinara Sauce $9 · Soup of the Day $7 · Salad Dressing $10
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="menu-cta">
        <div className="menu-cta__content">
          <h2>Ready to Dine With Us?</h2>
          <p>Call ahead for reservations or to inquire about catering and banquet services.</p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="tel:5869484900" className="btn-primary">586-948-4900</a>
            <Link to="/gallery" className="btn-outline btn-outline--light">View Gallery</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
